module.exports = __webpack_public_path__ + "img/title-bg.137057a6.png";